<app-header style="width: 100%"></app-header>
<section
    [ngClass]="fASelected ? '' : 'tw-pb-[45px]'"
    class="sme-new-app tw-bg-[#FFFBF8]"
>
    <div class="sme-container">
        <div
            class="tw-grid tw-items-center tw-grid-cols-1 md:tw-grid-cols-[calc(100%_-_310px),140px] tw-gap-[10px] tw-pt-[40px] tw-pb-[20px] md:tw-pt-[10px] md:tw-pb-[10px]"
        >
            <div></div>
            <div class="tw-invisible tw-hidden md:tw-block tw-text-right">
                <img
                    src="/assets/images/new-app-banner-1.png"
                    class="tw-inline-block"
                    alt="New Application Banner"
                />
            </div>
        </div>
        <div
            *ngIf="fASelected !== true"
            class="tw-grid tw-grid-cols-1 md:tw-grid-cols-[180px,calc(100%_-_180px)] lg:tw-grid-cols-[320px,calc(100%_-_320px)]"
        >
            <div
                class="tw-hidden md:tw-block tw-grid-cols-[1fr,1fr,1fr,40px] tw-justify-between tw-mb-[45px] md:tw-mb-0]"
            >
                <div
                    class="tw-items-center tw-gap-[18px] md:tw-max-w-[250px] tw-w-full tw-relative tw-mt-0 md:tw-mb-[65px] md:tw-justify-end tw-bg-[#FFF] tw-p-[20px]"
                >
                    <span
                        class="md:tw-inline-block tw-text-black tw-text-[14px] tw-leading-[20px] tw-font-[600]"
                    >
                        {{
                            "NEW_APPLICATION.SUBMISSION_SELECTION_1" | translate
                        }}
                    </span>
                    <span
                        class="md:tw-inline-block tw-text-black tw-text-[14px] tw-leading-[20px] tw-font-[600] tw-mt-4"
                    >
                        {{
                            "NEW_APPLICATION.SUBMISSION_SELECTION_2" | translate
                        }}
                        <br />
                        {{ "NEW_APPLICATION.CGC_EMAIL" | translate }}:
                        <span class="tw-text-sky-500">
                            {{ "imsme@cgc.com.my" }} </span
                        >.</span
                    >
                    <span
                        class="md:tw-inline-block tw-text-black tw-text-[14px] tw-leading-[20px] tw-font-[600] tw-mt-4"
                    >
                        {{
                            "NEW_APPLICATION.SUBMISSION_THANKS" | translate
                        }}</span
                    >
                </div>
            </div>

            <!-- implement Status component here-->

            <div class="md:tw-pl-[40px] lg:tw-pl-[75px]">
                <div
                    class="tw-flex tw-items-center tw-gap-3 sme-new-app tw-pb-5 tw-border-b tw-border-solid tw-border-[#8D8D8D]/[0.25]"
                >
                    <div>
                        <img
                            class="tw-w-[35px]"
                            src="/assets/images/matched-product/green-check.png"
                            alt="Check Icon"
                        />
                    </div>
                    <div
                        class="tw-text-[18px] md:tw-text-[24px] tw-font-semibold"
                    >
                        {{ "NEW_APPLICATION.SUBMISSION_SUCCESS" | translate }}
                    </div>
                    <!-- <div
                        class="tw-flex md:tw-hidden tw-basis-1/3 tw-justify-end"
                    >
                        <button
                            (click)="openDialog()"
                            class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-accent-blue-light tw-text-primary-blue tw-grid tw-place-items-center"
                        >
                            i
                        </button>
                    </div> -->
                </div>

                <ng-container>
                    <div
                        class="tw-grid tw-gap-[20px] md:tw-gap-[80px] md:tw-grid-cols-[260px,200px,260px] tw-mb-[28px] md:tw-mb-[25px] tw-border-b tw-border-solid tw-border-[#8D8D8D]/[0.25] tw-pb-[30px] tw-pt-[28px]"
                        *ngFor="let item of submissionDetails.case"
                    >
                        <div
                            class="tw-row-start-0 tw-row-end-0 md:tw-row-start-[unset] md:tw-row-end-[unset]"
                        >
                            <span
                                class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-caption-gray tw-font-[500] tw-mb-[4px] md:tw-mb-[8px]"
                                >{{
                                    "NEW_APPLICATION.SUBMISSION_PRODUCT"
                                        | translate
                                }}</span
                            >
                            <span
                                class="tw-block tw-text-black tw-text-[21px] md:tw-text-[20px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                                >{{ item.productName }}</span
                            >
                        </div>
                        <div
                            class="tw-row-start-[2.5] tw-row-end-[3] md:tw-row-start-[unset] md:tw-row-end-[unset]"
                        >
                            <span
                                class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-caption-gray tw-font-[500] tw-mb-[4px] md:tw-mb-[8px]"
                                >{{
                                    "NEW_APPLICATION.SUBMISSION_TICKET"
                                        | translate
                                }}</span
                            >
                            <span
                                class="tw-block tw-text-black tw-text-[21px] md:tw-text-[20px] tw-leading-normal md:tw-leading-[32px] tw-font-[600]"
                                >{{ item.ticketId }}</span
                            >
                        </div>
                    </div>
                </ng-container>

                <div
                    class="tw-flex tw-flex-wrap tw-gap-[10px] tw-items-center md:tw-bg-white md:tw-rounded-[80px] tw-py-[20px] tw-px-[0] md:tw-px-[15px] lg:tw-px-[27px]"
                >
                    <div
                        class="tw-order-2 md:tw-order-1 tw-flex-[0_0_100%] md:tw-flex-[0_0_calc(50%_-_10px)]"
                    >
                        <button
                            class="tw-text-center tw-text-[18px] tw-leading-[20px] tw-text-black tw-text-base tw-underline tw-font-medium md:tw-max-w-[175px] tw-w-full"
                            [attr.ga-event-id]="
                                prodCode
                                    ? prodCode + '_next_button_status_pg_click'
                                    : 'next_button_status_pg_click'
                            "
                            ga-event-category="Status Page Button"
                            [attr.ga-event-label]="
                                prodCode
                                    ? prodCode + ' Going Home Button'
                                    : 'Going Home Button'
                            "
                            ga-track="track"
                            [routerLink]="['/home']"
                        >
                            {{
                                "NEW_APPLICATION.SUBMISSION_TO_HOME" | translate
                            }}
                        </button>
                    </div>
                    <div
                        class="tw-order-1 md:tw-order-2 md:tw-text-right tw-flex-[0_0_100%] md:tw-flex-[0_0_50%] tw-mb-[18px] md:tw-mb-0"
                    >
                        <button
                            [attr.ga-event-id]="
                                prodCode
                                    ? prodCode + '_dashboard_click'
                                    : 'dashboard_click'
                            "
                            ga-event-category="Status Page Button"
                            [attr.ga-event-label]="
                                prodCode
                                    ? prodCode + ' Dashboard Button Click'
                                    : 'Dashboard Button Click'
                            "
                            ga-track="track"
                            class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300 tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                            (click)="goToDashboard()"
                        >
                            {{ "NEW_APPLICATION.DASHBOARD" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- implement Status component here -->
        </div>

        <div
            *ngIf="fASelected == true"
            class="md:tw-pl-[40px] lg:tw-pl-[75px] tw-w-full tw-max-w-[720px]"
        >
            <div
                class="tw-flex tw-items-center tw-gap-2 sme-new-app tw-pb-5 tw-border-b tw-border-solid tw-border-[#8D8D8D]/[0.25]"
            >
                <div>
                    <img
                        class="tw-w-[35px]"
                        src="/assets/images/matched-product/green-check.png"
                        alt="Check Icon"
                    />
                </div>
                <div class="tw-text-[18px] md:tw-text-[24px] tw-font-semibold">
                    {{ "NEW_APPLICATION.SUBMISSION_SUCCESS" | translate }}
                </div>
                <!-- <div class="tw-flex md:tw-hidden tw-basis-1/3 tw-justify-end">
                    <button
                        (click)="openDialog()"
                        class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-accent-blue-light tw-text-primary-blue tw-grid tw-place-items-center"
                    >
                        i
                    </button>
                </div> -->
            </div>
            <ng-container>
                <p
                    class="tw-mb-[28px] !tw-font-normal !tw-text-[16px] !tw-text-gray-700 md:tw-mb-[25px] tw-pb-[30px] tw-pt-[28px]"
                    [innerHtml]="
                        'NEW_APPLICATION.FINANCIAL_ADVISORY_SUCCESS' | translate
                    "
                ></p>
            </ng-container>
            <div class="tw-mt-[20px]">
                <button
                    [attr.ga-event-id]="
                        prodCode
                            ? prodCode + '_dashboard_click'
                            : 'dashboard_click'
                    "
                    ga-event-category="Status Page Button"
                    [attr.ga-event-label]="
                        prodCode
                            ? prodCode + ' Dashboard Button Click'
                            : 'Dashboard Button Click'
                    "
                    ga-track="track"
                    class="tw-text-[18px] tw-leading-[20px] md:tw-max-w-[175px] tw-w-full tw-text-center tw-font-[600] tw-bg-gradient-to-r tw-from-orange-400 tw-to-amber-300 tw-rounded-[32px] tw-text-white tw-py-[22px] tw-px-[15px]"
                    (click)="fASelected ? goToHome() : goToDashboard()"
                >
                    {{
                        (fASelected
                            ? "BACK_TO_IMSME"
                            : "NEW_APPLICATION.DASHBOARD"
                        ) | translate
                    }}
                </button>
            </div>
        </div>

        <img
            *ngIf="fASelected == true"
            class="md:tw-h-[500px] tw-mx-auto md:tw-ml-auto md:tw-mr-0 md:tw-mt-[-245px]"
            src="/assets/images/matched-product/girl.png"
            alt="girl"
        />
    </div>
</section>
<app-footer></app-footer>
